import { render } from "./Swiper_3.vue?vue&type=template&id=03b58dde"
import script from "./Swiper_3.vue?vue&type=script&lang=js"
export * from "./Swiper_3.vue?vue&type=script&lang=js"

import "./Swiper_3.vue?vue&type=style&index=0&id=03b58dde&lang=scss"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__